<template>
  <div class="user">
    <!-- 搜索 -->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm">
        <el-form-item label="搜索">
          <el-input
            v-model="searchForm.search"
            placeholder="昵称 / 手机号"
            clearable
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="nickName" label="昵称" />
          <el-table-column prop="mobile" label="手机号" />
          <el-table-column prop="order_count" label="订单数" width="80" />
          <el-table-column label="净消费" width="110">
            <template slot-scope="scope">$ {{ scope.row.total_spend }}</template>
          </el-table-column>
          <el-table-column prop="repurchase_count" label="复购次数" width="90" />
          <el-table-column label="最近下单">
            <template slot-scope="scope">
              {{ scope.row.last_order_time | timeFormat }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                v-auth="'/order/customer/detail'"
                @click="toDetail(scope.row)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerApi from '@/api/customer.js'

export default {
  name: 'CustomerIndex',
  filters: {
    timeFormat(val) {
      if (!val) return '-'
      const d = typeof val === 'number' ? new Date(val * 1000) : new Date(val.replace(/-/g, '/'))
      return isNaN(d.getTime()) ? val : d.toLocaleString('zh-CN', { hour12: false })
    }
  },
  data() {
    return {
      loading: true,
      tableData: [],
      total: 0,
      curPage: 1,
      pageSize: 20,
      searchForm: { search: '' }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    onSearch() {
      this.curPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.curPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      CustomerApi.list({
        ...this.searchForm,
        page: this.curPage,
        list_rows: this.pageSize
      }).then(res => {
        this.tableData = res.data.list.data
        this.total = res.data.list.total
        this.loading = false
      })
    },
    toDetail(row) {
      this.$router.push({ path: '/order/customer/detail', query: { user_id: row.user_id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/order/customer/index.vue